<template>
  <el-dialog
    :title="'选择编号' + '(已选' + reserveTable.length + '个)'"
    v-model="visible"
    :close-on-click-modal="false"
    width="900px"
  >
    <el-form :model="searchData" :inline="true" ref="searchRef">
      <el-form-item label="表具编号：" prop="number">
        <el-input v-model="searchData.number" placeholder="请输入" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="Search" @click="getList()"
          >查询</el-button
        >
        <el-button icon="Refresh" @click="handleReset()">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      v-loading="loading"
      :data="tableData"
      ref="tableRef"
      @selection-change="handleSelectionChange"
      row-key="id"
    >
      <el-table-column type="selection" width="55" :reserve-selection="true" />
      <template v-for="item in columns" :key="item.prop">
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          show-overflow-tooltip
          v-if="item.show ?? true"
        >
          <template #default="{ row }">
            <span>
              {{ row[item.prop] || "-" }}
            </span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      v-if="pages.total > 0"
      background
      style="margin-top: 10px"
      :current-page="pages.page"
      :page-size="pages.size"
      :page-sizes="[10, 20, 30, 50]"
      :total="pages.total"
      layout="->, total, prev, pager, next, sizes, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="handleSelectionComplete()">
          确定
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref, toRaw } from "vue";
import { GetKeyMaterialPage } from "@/api/keyMaterial";
import { ElMessage } from "element-plus";
import { set } from "lodash";

// 弹窗控制
const visible = ref(false);

// 搜索表单ref
const searchRef = ref(null);

// 表格的ref
const tableRef = ref(null);

// 搜索条件
const searchData = reactive({
  warehouseId: null,
  materialId: null,
  number: "",
});

// 表格列配置
const columns = ref([
  {
    label: "物料名称",
    prop: "materialName",
  },
  {
    label: "物料编号",
    prop: "materialNumber",
  },

  {
    label: "规格型号",
    prop: "materialModel",
  },
  {
    label: "表具编号",
    prop: "number",
  },
]);

// 表格遮罩
const loading = ref(false);

// 表格数据
const tableData = ref([]);

// 父组件传进来的表格
const reserveTable = ref([]);

// 分页数据
const pages = reactive({
  page: 1,
  size: 10,
  total: 0,
});
const handleSizeChange = (val) => {
  pages.size = val;
  pages.page = 1;
  getList();
};
const handleCurrentChange = (val) => {
  pages.page = val;
  getList();
};

// 表格数据
const original_row = ref(null); // 原生row引用地址
// requireNumber(选填) 需要填写的数量,不传不做数量校验
const requireNumber = ref(0); // 需求数量 0不做限制
// 弹窗打开
const handleDialogOpen = (data) => {
  const { row, requireNumber: _requireNumber } = data;
  tableRef.value?.clearSelection();
  requireNumber.value = _requireNumber || 0;
  searchData.warehouseId = row.warehouseId;
  searchData.materialId = row.materialId;
  reserveTable.value = row.keyNumberList;
  original_row.value = row;
  getList();
  visible.value = true;
};

const isReserveSelecting = ref(false); // 是否正在选择
// 获取数据
const getList = () => {
  loading.value = true;
  GetKeyMaterialPage({ ...searchData, page: pages.page, limit: pages.size })
    .then((res) => {
      tableData.value = res.data.records;
      pages.total = res.data.total;
    })
    .finally(() => {
      loading.value = false;
      // 设置标志位为 true，表示正在反选
      isReserveSelecting.value = true;
      reserveSelect();
      // 反选完成后，将标志位设置为 false
      setTimeout(() => {
        isReserveSelecting.value = false;
      });
    });
};

// 反选表格
const reserveSelect = () => {
  tableData.value.forEach((item) => {
    if (reserveTable.value.includes(item.number)) {
      tableRef.value?.toggleRowSelection(item, true);
    }
  });
};

// 数据选中事件
const handleSelectionChange = (selection) => {
  // 如果正在反选，则不处理
  if (isReserveSelecting.value) {
    return;
  }

  console.log("表格选中发生变化===>", selection);

  // 获取当前页所有行的 number 集合
  const currentPageNumbers = tableData.value.map((item) => item.number);

  // 获取选中行的 number 集合
  const selectedNumbers = selection.map((item) => item.number);

  // 找出当前页未选中的行（即取消选中的行）
  const unselectedNumbers = currentPageNumbers.filter(
    (num) => !selectedNumbers.includes(num)
  );

  // 从 reserveTable 中移除未选中的 number
  reserveTable.value = reserveTable.value.filter(
    (num) => !unselectedNumbers.includes(num)
  );

  // 将选中的 number 添加到 reserveTable 中（如果不存在）
  selectedNumbers.forEach((num) => {
    if (!reserveTable.value.includes(num)) {
      reserveTable.value.push(num);
    }
  });

  console.log("更新后的 reserveTable:", reserveTable.value);
};

// 点击确定按钮
const handleSelectionComplete = () => {
  if (
    requireNumber.value &&
    reserveTable.value.length !== requireNumber.value
  ) {
    ElMessage.error("选中表具编号数量必须与出库数量一致!");
    return;
  }
  original_row.value.keyNumberList = reserveTable.value;
  visible.value = false;
  console.log("点击确定===>", original_row);
};

// 重置
const handleReset = () => {
  searchRef.value?.resetFields();
  pages.page = 1;
  getList();
};

defineExpose({
  handleDialogOpen,
});
</script>

<style scoped></style>
